export default __webpack_public_path__ + "static/media/apple-pay-icon-gray.9f3ff99b.svg";